import React from 'react';
import { FlagIcon } from './UI';
export const TopBar = () => {
  return <div className="bg-base-black border-b border-acid-green-border py-2 px-4 text-xs font-barlow tracking-wider flex flex-col sm:flex-row justify-between items-center gap-1 sm:gap-0 z-50 relative" data-id="element-656">
      <div className="flex items-center text-acid-green" data-id="element-657">
        <span className="w-2 h-2 rounded-full bg-acid-green animate-pulse mr-2" data-id="element-658"></span>
        OPERATIONAL — UNITS DEPLOYING NOW
      </div>

      <div className="flex items-center space-x-4 text-text-dimmed hidden md:flex" data-id="element-659">
        <span className="text-white" data-id="element-660">
          FREE SHIPPING ON ALL ORDERS IN THE USA
        </span>
        <span data-id="element-661">|</span>
        <span data-id="element-662">BUILT BY OPERATORS. FOR OPERATORS.</span>
        <span data-id="element-663">|</span>
        <span className="flex items-center gap-2" data-id="element-664">
          <FlagIcon className="w-4 h-3" data-id="element-665" /> AMERICAN MADE
        </span>
      </div>

      <div className="flex items-center gap-2 text-text-dimmed sm:hidden" data-id="element-666">
        <span className="text-white" data-id="element-667">
          FREE SHIPPING ON ALL ORDERS IN THE USA
        </span>
      </div>
    </div>;
};